// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
// import cssVars from 'css-vars-ponyfill';

import '@/_axios';
import '@/_moment';
// import IsOffline from '@/_isOffline';
import { i18n, loadLang } from '@/_translate';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Alerts from 'vue-notification';
import store from '@/store/index';
import App from '@/App';
import router from '@/router';

import AlertsMixin from '@/mixins/AlertsMixin';
import FormErrors from '@/mixins/FormErrors';
import DatePickerMixin from '@/mixins/DatePickerMixin';

loadLang(i18n.locale, true);

Vue.use(BootstrapVue);
Vue.use(Alerts, { componentName: 'Alerts' });

Vue.mixin(AlertsMixin);
Vue.mixin(FormErrors);
Vue.mixin(DatePickerMixin);

// Vue.use(IsOffline, { pingUrl: (`${Backend.defaults.baseURL}/ping`).replace(/([^:]\/)\/+/g, '$1') });

Vue.filter('flag', (langKey) => {
  const extraFlags = {
    en: 'gb-eng'
  };
  if (extraFlags[langKey]) {
    return extraFlags[langKey];
  }
  return langKey;
});

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  store
});
